import { useQuery } from "react-query";

import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { parseAndSelect } from "src/api/apiHelpers.ts";
import { RoleSchema } from "src/api/client-api/roles/useGetRole.ts";

export const getAllRolesKey = "allRoles" as const;

export type UseGetAllRolesOptions = {
    enabled?: boolean;
};

export const useGetAllRoles = (options?: UseGetAllRolesOptions) => {
    const { enabled = true } = options ?? {};
    const query = useQuery({
        queryKey: getAllRolesKey,
        enabled,
        queryFn: async () => {
            return await loggedInApiCall.get("/api/roles");
        },
        select: (request) => parseAndSelect(request, RoleSchema.array(), getAllRolesKey),
    });

    return {
        allRoles: query.data?.items,
        totalItems: query.data?.totalItems,
        ...query,
    };
};
